module.exports = __webpack_public_path__ + "images/emoji/spaghetti.5d44bcff7b520f92193f.png";